import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';

import theme from './theme';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Auth0Provider } from '@auth0/auth0-react';
import config from "./auth_config.json";
import history from "./utils/history";

const CASEGRAF_LP_URL = window.location.origin === 'http://localhost:3001' ? 'http://localhost:3001' : 'https://app.casegraf.com';

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <Auth0Provider
          domain={config.domain}
          clientId={config.clientId}
          redirectUri={CASEGRAF_LP_URL}
          onRedirectCallback={onRedirectCallback}
        >
            <App />
        </Auth0Provider>
      </Router>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
